import 'barcode-detector/polyfill';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// ── KIOSKDIAG boot canary ──────────────────────────────────────────────────
// Fires the instant the JS bundle is parsed. If this line does NOT appear in
// the BrowserStack App Live "Device Logs - Console" panel (search: KIOSKDIAG)
// after launching the app, then Capacitor's WebView->native console bridge
// isn't forwarding output. In that case ios.loggingBehavior in
// capacitor.config.ts didn't take effect — likely because cap copy/sync
// didn't run for this IPA, or the IPA being tested predates the config change.
// (Three levels are emitted so we can see which os_log levels actually surface.)
// eslint-disable-next-line no-console
console.log('[KIOSKDIAG] BUNDLE_BOOT main.ts loaded — log level');
// eslint-disable-next-line no-console
console.warn('[KIOSKDIAG] BUNDLE_BOOT warn level');
// eslint-disable-next-line no-console
console.error('[KIOSKDIAG] BUNDLE_BOOT error level');

window.addEventListener('error', (e: ErrorEvent) => {
  // eslint-disable-next-line no-console
  console.error(`[KIOSKDIAG] window.error msg=${e?.message} src=${e?.filename}:${e?.lineno}:${e?.colno}`);
});
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  // eslint-disable-next-line no-console
  console.error(`[KIOSKDIAG] window.unhandledrejection reason=${(e?.reason as any)?.message || e?.reason}`);
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
